import { useState, useRef, useEffect, SyntheticEvent, useCallback } from "react";
import { useUiStore } from "src/components/main/uiStore";
//--------------------------------------------------------------------------------------------
import redoImg from "src/img/sketches/redo.png";
import undoImg from "src/img/sketches/undo.png";
import clearImg from "src/img/sketches/clear.png";
import penImg from "src/img/sketches/pen.png";
import Modal from "src/components/common/Modal";
import { 
    ss, 
    PicDataArrs, 
    xyDataArr, 
    xyDataItem, 
    PicDataItem, 
    PicDataArr, 
    cssjson, 
    json
} from "src/components/common/types";
import { useAuthStore } from "src/components/main/authStore";
import {
    myAxios} from  "src/components/common/functions";
import { useGlobalMouse } from "src/useGlobalMouse";
//--------------------------------------------------------------------------------------------
export default function Esigns({ 
    picDatas, 
    setPicDatas, 
    signIndex, 

    prefix, 
    id, 
    defaultSignId, 
    disableDefaultSign, 
    email, 
    buttonClassName, 
}:{ 
    picDatas:PicDataArrs, 
    setPicDatas: ss<PicDataArrs>, 
    signIndex: number,
    
    prefix: string, 
    id: number, 
    defaultSignId: string, 
    disableDefaultSign: boolean, 
    email: string, 
    buttonClassName: string, 
}){
    const mouse = useGlobalMouse();
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const user = useAuthStore(state => state.user);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      useEffect(() => {
        const handleResize = () => {
            window.setTimeout(() => {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }, 500);
            //window.orientation; //0, 90, -90, undefined
        }
        window.addEventListener("orientationchange", handleResize);
        handleResize();
        return () => window.removeEventListener("orientationchange", handleResize);
      }, []);
    //--------------------------------------------------------------------------------------------
    let iconStyle2Index = 0;
    //--------------------------------------------------------------------------------------------
    const eraserRatio = 4;
    const [curId, setCurId] = useState(defaultSignId);
    const [drawMode, setDrawMode] = useState("pen");
    const [isMouseDown, setIsMouseDown] = useState(false);
    const [currentStep, setCurrentStep] = useState<xyDataArr>([]);
    const [undoData, setUndoData] = useState<PicDataArr>([]);
    const [startPos, setStartPos] = useState<xyDataItem>({x :0, y: 0});
    const [atDefault, setDefualt] = useState(false);
    const [showModal, setShowModal] = useState(false);
    //--------------------------------------------------------------------------------------------
    const canvasRef = useRef(null);
    //--------------------------------------------------------------------------------------------
    const iconStyle2 = (index:number):cssjson => ({
        width: "40px", 
        position: "absolute", 
        top: `${-30 + 47 * index}px`, 
        right:  "23px", 
        padding: "5px"
    });
    const onMouseDown = (e: SyntheticEvent) => {
        setUndoData([]);
        setIsMouseDown(true);
        const canvas = e.currentTarget as HTMLCanvasElement;
        let mouseEvent;
        if(e.nativeEvent instanceof TouchEvent){
            if(e.nativeEvent.touches.length === 1){
                mouseEvent = e.nativeEvent.touches[0];
            }else{
                return;
            }
        }else if(e.nativeEvent instanceof MouseEvent){
            mouseEvent = e.nativeEvent;
        }
        const context = canvas.getContext("2d")!;
        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        const x:number = (mouseEvent?.clientX! - rect.left) * scaleX;
        const y:number = (mouseEvent?.clientY! - rect.top) * scaleY;
        context.beginPath();
        switch(drawMode){
            case "pen":
                setStartPos({x: x , y: y});
                setCurrentStep([{x: x ,y: y}])
            break;
            case "eraser":
                context.strokeStyle = "#fff";
                context.lineWidth = eraserRatio;
                context.lineCap = "round";
                setStartPos({x: x , y: y});
                setCurrentStep([{x: x ,y: y}])
            break;
            default:
        }
    }
    const onMouseMove = (e: SyntheticEvent) => {
        if(!isMouseDown) return;
        const canvas = e.currentTarget as HTMLCanvasElement;
        let mouseEvent;
        if(e.nativeEvent instanceof TouchEvent){
            if(e.nativeEvent.touches.length === 1){
                mouseEvent = e.nativeEvent.touches[0];
            }else{
                return;
            }
        }else if(e.nativeEvent instanceof MouseEvent){
            mouseEvent = e.nativeEvent;
        }
        const context = canvas.getContext("2d")!;
        const rect = canvas.getBoundingClientRect(),
        scaleX = canvas.width / rect.width,
        scaleY = canvas.height / rect.height;
        const x = (mouseEvent?.clientX! - rect.left) * scaleX;
        const y = (mouseEvent?.clientY! - rect.top) * scaleY;
        drawCanvas(picDatas[signIndex].data || []);
        switch(drawMode){
            case "pen":
                context.moveTo(startPos.x, startPos.y);
                currentStep.forEach(step => {context.lineTo(step.x, step.y)});
                setCurrentStep([...currentStep, {x: x, y: y}]);
                context.lineTo(x, y);
                context.stroke();
            break;
            default:
        }
    }
    const onMouseUp = () => {
        setIsMouseDown(false);
        switch(drawMode){
            case "pen":
                setPicDatas([...picDatas.slice(0, signIndex),{...picDatas[signIndex], data: [...picDatas[signIndex].data, {
                    data:currentStep,
                    drawMode:"pen"
                }]},...picDatas.slice(signIndex + 1)]);
                setDefualt(false);
                break;
            default:
        }
    }
    const onMouseOut = (e: SyntheticEvent) => {
        if(!mouse.isDown()) return;
        onMouseUp();
    }
    const onMouseOver = (e: SyntheticEvent) => {
        if(!mouse.isDown()) return;
        onMouseDown(e);
    }
    const drawCanvas = useCallback((pD?: PicDataArr) => {
        const localPD = pD ?? (picDatas[signIndex].data || []);
        const canvas = canvasRef.current! as HTMLCanvasElement;
        if(canvas){
            const context = canvas.getContext("2d");
            context!.clearRect(0, 0, canvas.width, canvas.height);
            localPD.forEach((currentPicData: PicDataItem) => {
                context!.beginPath();
                switch(currentPicData.drawMode){
                    case "pen":
                        context!.moveTo(currentPicData.data[0].x , currentPicData.data[0].y);
                        currentPicData.data.forEach((step: xyDataItem) => {
                            context!.lineTo(step.x, step.y);
                        })
                        context!.stroke();
                    break;
                    default:
                }
            })
            context!.beginPath();
        }
    }, [picDatas, signIndex]);
    useEffect(() => {
        drawCanvas();
    }, [picDatas, signIndex, windowSize, drawCanvas])
    //--------------------------------------------------------------------------------------------
    return(
        <>
        <div className = {buttonClassName || "m-4"}>
            <span
                className = {`btn btn-${picDatas[signIndex].data.length?"success":"primary"}`}
                onClick = {e => {
                    if(windowSize.height > windowSize.width){
                        window.alert("Please change to landscape view to sign.");
                        return;
                    }
                    e.currentTarget.blur();
                    setShowModal(true);
                }
            }>
                {
                picDatas[signIndex].data.length?
                <>Edit Signature</>
                :
                <>Click to Sign</>
                }
            </span>
        </div>
        <Modal
            show = {showModal && windowSize.height < windowSize.width?"":"none"}
            width = {"100%"} 
            title = {(prefix?prefix + " ":"") + "Signature"} 
            closeIt = {() => {
                setShowModal(false);
            }}
        >
        <section className = "esign">
            <div className = "my-3">
                    {!disableDefaultSign?<div className = "p-3">
                    {curId?(!atDefault?
                    <span className = "btn btn-primary ms-3" onClick = {async () => {
                        const formData = new FormData();
                        formData.append("fileId", curId);
                        //-------------------------------------------------------------
                        setShowLoader(true);
                        const res: json | false = await myAxios({ fileName: "common/getJSONData.php", formData: formData });
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------
                        setPicDatas([...picDatas.slice(0, signIndex),
                            {...picDatas[signIndex], data: res.data}
                                ,...picDatas.slice(signIndex + 1)]);
                        setDefualt(true);
                    }}>
                        Use Default
                    </span>
                    :null
                    ):null}
                    {atDefault?null:<span className = "btn btn-info ms-3" onClick = {async () => {
                        if(!window.confirm("Are you sure to make the current draing your default signature?")) return;
                        
                        const formData = new FormData();
                        formData.append("userEmail", email || user!.email!);
                        formData.append("signData", JSON.stringify(picDatas[signIndex].data));
                        //-------------------------------------------------------------
                        setShowLoader(true);
                        const res: json | false = await myAxios({ fileName: "common/setDefaultSign.php", formData: formData });
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------
                        setCurId(res.data);
                        setDefualt(true);
                    }}>
                        Set Default
                    </span>}
                </div>:null}
                <canvas id = {`esign${id === 0 ? 0 : (id || "")}`} ref = {canvasRef} className = "block mx-auto noDefaultTouchAction border penCursor"
                width = {windowSize.width - 106} height = {windowSize.height * 0.6}
                    onMouseDown = {onMouseDown}
                    onMouseMove = {onMouseMove}
                    onMouseUp = {onMouseUp}
                    onMouseOut = {onMouseOut}
                    onMouseOver = {onMouseOver}
                    onTouchStart = {onMouseDown}
                    onTouchMove = {onMouseMove}
                    onTouchEnd = {onMouseUp}
                    onTouchCancel = {onMouseOut}
                />
            </div>
            <div className = "my-3">
                <img className = {`${drawMode === "pen"?"bg-primary":null} pointer rounded`} src = {penImg} alt = "" style = {iconStyle2(++iconStyle2Index)} onClick = {() => {
                    setDrawMode("pen");
                }}/>
                <img className = "pointer" src = {undoImg} alt = "" style = {iconStyle2(++iconStyle2Index)} onClick = {() => {
                    if(picDatas[signIndex].data[0]){
                        setUndoData([...undoData, picDatas[signIndex].data[picDatas[signIndex].data.length - 1]]);
                        setPicDatas([...picDatas.slice(0, signIndex), 
                            {...picDatas[signIndex], data: 
                                picDatas[signIndex].data.slice(0, -1)
                            },
                             ...picDatas.slice(signIndex + 1)]);
                        setDefualt(false);
                    }
                }}/>
                <img className = "pointer" src = {redoImg} alt = "" style = {iconStyle2(++iconStyle2Index)} onClick = {() => {
                    if(undoData[0]){
                        setPicDatas([...picDatas.slice(0, signIndex), 
                            {...picDatas[signIndex], data: [...picDatas[signIndex].data, undoData[undoData.length - 1]]}
                        ,...picDatas.slice(signIndex + 1)]);
                        setUndoData(undoData.slice(0, -1));
                        setDefualt(false);
                    }
                }}/>
                <img className = "pointer" src = {clearImg} alt = "" style =  {iconStyle2(++iconStyle2Index)}  onClick = {() => {
                    if(!window.confirm("are you sure to clear all the drawings?")) return;
                    setPicDatas([...picDatas.slice(0, signIndex), 
                        {...picDatas[signIndex], data: []}
                        ,...picDatas.slice(signIndex + 1)]);
                    setDefualt(false);
                }}/>
            </div>
        </section>
        </Modal>
        </>
    )    
}